import React from "react";
import update from "immutability-helper";
import { get, map, includes, filter, isEmpty } from "lodash";

import DashboardCard from "../DashboardCard";
import ScrollableTable from "../../Common/Table/ScrollableTable";
import HspCurrentStatusTableRow from "./HspCurrentStatusTableRow";

import images from "../../../assets/img/images";

const columns = [
  {
    name: "site_ref",
    minWidth: 100,
    width: 100,
  },
  {
    name: "site_dateTime",
    minWidth: 150,
  },
  {
    name: "site_profileName",
    minWidth: 150,
  },
  {
    name: "profiles_tag",
    minWidth: 150,
  },
  {
    name: "site_site2",
    minWidth: 150,
  },
  {
    name: "site_zone",
    minWidth: 150,
  },
  {
    name: "profiles_verification",
    minWidth: 240,
  },
  {
    name: "luke_action",
    id: 158,
    minWidth: 240,
  },
  {
    minWidth: 60,
    icon: images.temperatureIcon,
    iconName: "dashboard_fever",
  },
  {
    name: "decision",
    id: 105,
    minWidth: 150,
    width: 150,
    filter: {
      name: 105,
      type: "select",
    },
  },
];

const HspCurrentStatusTable = (props) => {
  const { data, lov, filters, setFilters } = props;

  const handleFilterChange = (value, field) => {
    if (includes(value, "selectAll")) {
      value = map(get(lov, [field]), (item) => item.id);
    } else if (includes(value, "selectNone")) {
      value = [];
    }
    const newFilters = update(filters, {
      [field]: { $set: value },
    });
    setFilters(newFilters);
  };

  const applyFilter = (item) => {
    return (
      isEmpty(get(filters, [105])) ||
      includes(get(filters, [105]), get(item, ["main", "entryStatusId"]))
    );
  };

  /*const dataFunctions = [];
  dataFunctions.push((item) => get(item, ["event_group_parent_id"]));
  dataFunctions.push((item) => formatDate(get(item, ["start"])));
  dataFunctions.push((item) => get(item, ["name"]));
  dataFunctions.push((item) =>
    get(
      filter(get(lov, ["tags"]), (t) => t.id === get(item, ["profile_tag_id"])),
      [0, `name_${language}`]
    )
  );
  dataFunctions.push(
    (item) =>
      get(
        filter(
          get(lov, ["zones"]),
          (z) => get(z, ["site_id"]) === get(item, ["site_id"])
        ),
        [0, "site_name"]
      ) || "-"
  );
  dataFunctions.push(
    (item) =>
      get(
        filter(
          get(lov, ["zones"]),
          (z) => get(z, ["zone_id"]) === get(item, ["zone_id"])
        ),
        [0, "zone_name"]
      ) || "-"
  );
  dataFunctions.push((item) =>
    get(
      filter(
        get(lov, ["eventTypes"]),
        (e) =>
          get(e, ["id"]) ===
          (get(item, ["event_type_id"]) === 91
            ? 81
            : get(item, ["event_type_id"]))
      ),
      [0, `name_${language}`]
    )
  );
  dataFunctions.push((item) =>
    get(
      filter(
        get(lov, [158]),
        (attrValue) => get(attrValue, ["id"]) === get(item, ["lukeaction"])
      ),
      [0, `name_${language}`]
    )
  );
  dataFunctions.push((item) =>
    get(item, ["fever"]) === true
      ? I18n.get("profiles_yes")
      : get(item, ["fever"]) === false
      ? I18n.get("profiles_no")
      : ""
  );
  dataFunctions.push((item) =>
    get(
      filter(
        get(lov, [105]),
        (attrValue) => get(attrValue, ["id"]) === get(item, ["decision"])
      ),
      [0, `name_${language}`]
    )
  );*/

  return (
    <DashboardCard
      size={"calc(100vw - 113px)"}
      style={{
        overflow: "auto",
        height: "calc(100vh - 498px)",
        padding: 0,
      }}
    >
      <ScrollableTable
        columns={columns}
        hasMore={false}
        stickyHeader
        lov={lov}
        filters={filters}
        handleFilterChange={handleFilterChange}
      >
        {map(filter(data, applyFilter), (item, index) => (
          <HspCurrentStatusTableRow
            key={index}
            item={item}
            index={index}
            refresh={props.refresh}
          />
        ))}
      </ScrollableTable>
    </DashboardCard>
  );
};

export default HspCurrentStatusTable;
